import { render, staticRenderFns } from "./PoweredBy.vue?vue&type=template&id=70c97de5&"
import script from "./PoweredBy.vue?vue&type=script&lang=js&"
export * from "./PoweredBy.vue?vue&type=script&lang=js&"
import style0 from "./PoweredBy.vue?vue&type=style&index=0&id=70c97de5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports